import React,{useEffect} from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { VariableAccounts } from './VariableAccounts';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';
import { getPageList, putAccount } from '../../../store/Actions/ActionAccounts';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { formatNumberWithCommas } from '../../../components/general/general-component/abstruct-component/FunctionRemoveCommas';

function EditAccount({ arr,open, setOpen }) {
    let { mode, dispatch,langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { page_list, loadingPageList } = useSelectorCustom()
    const { state, setStateCustom, setLoad,setState } = VariableAccounts()
    useEffect(()=>{
        dispatch(getPageList())
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            type: arr.type,
            amount: formatNumberWithCommas(arr.amount),
            user_name: arr?.user?.name,
            user_id: arr?.user?.id,
            status: arr.status === 1? 1 : 0,
            account_type_id: arr?.account_type?.id,
            account_type_name: arr?.account_type?.name
        }));
    },[])
    const Submit = e => {
        e.preventDefault()
        dispatch(putAccount(arr.id,state, setLoad))
    }
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: "type", label: "type", type: "text", inputType: 'text', iconType: "pencil" },
        {
            name: "account_type_id", label: "type", type: "text", inputType: 'one_select', iconType: "user",
            options: page_list?.account_types?.map((type) => ({
                label: type?.name, value: type?.id
            })),
            defaultvaluee: {value: state.account_type_id , label: state.account_type_name }
        },
        { name: "amount", label: "amount", type: "text", inputType: 'text', iconType: "pencil",disabled: true },
        {
            name: "user_id", label: "user_name", type: "text", inputType: 'one_select', iconType: "user",
            options: page_list?.users?.map((user)=>({
                value: user?.id,label: user?.name
            })),
            defaultvaluee: {value: state.user_id , label: state.user_name }
        },
        {
            name: 'status',
            label: 'Status',
            type: 'text',
            inputType: 'one_select',
            iconType: "check",
            options:  page_list?.statuses
        },
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup":"lighttoppopup"}`}  >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`} >{translate('edit_account')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    )
}

export default EditAccount

